var map = {
	"./en/1-1/appstore.png": 82340,
	"./fi/1-1/appstore.png": 14634,
	"./in/1-1/appstore.png": 44016,
	"./th/1-1/appstore.png": 608,
	"./tw/1-1/appstore.png": 54750,
	"./zh/1-1/appstore.png": 14169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92380;